import * as React from "react";

const ButtonGroup = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#7B838C" d="M6 9.75h48v20H6z" />
      <path
        d="M32.488 24l-.78-1.812h-3.516L27.412 24H25.42l3.624-8.388h1.812L34.48 24h-1.992zm-2.532-5.892L28.9 20.544H31l-1.044-2.436z"
        fill="#FFF"
      />
      <g>
        <path fill="#7B838C" d="M11 35.75h48v20H11z" />
        <path
          d="M35.52 50h-3.672v-8.388h3.264c.568 0 1.058.068 1.47.204.412.136.722.32.93.552.376.432.564.92.564 1.464 0 .656-.212 1.144-.636 1.464a2.292 2.292 0 0 1-.3.21 8.516 8.516 0 0 1-.3.138c.52.112.934.346 1.242.702.308.356.462.798.462 1.326 0 .584-.2 1.1-.6 1.548-.464.52-1.272.78-2.424.78zm-1.8-4.992h.888c.52 0 .906-.056 1.158-.168.252-.112.378-.354.378-.726s-.116-.618-.348-.738c-.232-.12-.624-.18-1.176-.18h-.9v1.812zm0 3.408h1.284c.536 0 .938-.066 1.206-.198s.402-.392.402-.78-.142-.644-.426-.768c-.284-.124-.738-.186-1.362-.186H33.72v1.932z"
          fill="#FFF"
        />
      </g>
    </g>
  </svg>
);

export default ButtonGroup;

